/* eslint-disable */
import {
  assertBoolean,
  attributeSelectionComponent,
  dimensionIndicatorComponent,
  materialSwatchComponent,
  memoEval,
  sceneEntityObjectRemoteMaterialOverrideComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'
import { Finishes } from '../model/index.js'

export const baseComponents = [
  attachComponent
    .withComponent(dimensionIndicatorComponent, 'widthIndicator', true)
    .withAlias('Base')
    .withGradualFilter({
      navigationStates: ['Shape', 'Base', 'Wood', 'Appearance', 'Accessories', 'Summary'],
      active: self => self.$widthIndicatorVisible,
    })
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$widthIndicatorStartX,
            self.$widthIndicatorFixedY,
            self.$widthIndicatorFixedZ,
            self.$widthIndicatorEndX,
            self.$widthIndicatorExtrusionZ,
          ],
        (
          $widthIndicatorStartX,
          $widthIndicatorFixedY,
          $widthIndicatorFixedZ,
          $widthIndicatorEndX,
          $widthIndicatorExtrusionZ
        ) => ({
          startX: $widthIndicatorStartX,
          startY: $widthIndicatorFixedY,
          startZ: $widthIndicatorFixedZ,
          endX: $widthIndicatorEndX,
          endY: $widthIndicatorFixedY,
          endZ: $widthIndicatorFixedZ,
          extrusionX: 0,
          extrusionY: 0,
          extrusionZ: $widthIndicatorExtrusionZ,
          extrusionLineDashed: true,
          indicatorAlwaysVisible: false,
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'base', true)
    .withAlias('Base')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$repeatX,
            self.$repeatY,
          ],
        (
          $fileUrl,
          $finishColor,
          $textureUrl,
          $normalMapUrl,
          $roughnessMapUrl,
          $aoMapUrl,
          $materialRoughness,
          $materialMetalness,
          $materialEnvMapIntensity,
          $materialSpecularIntensity,
          $materialNormalScale,
          $materialReflectivity,
          $repeatX,
          $repeatY
        ) => ({
          materialsToOverride: ['SupportMaterial'],
          fileUrl: $fileUrl,
          materialName: 'SupportMaterial',
          color: $finishColor,
          textureUrl: $textureUrl,
          normalMapUrl: $normalMapUrl,
          roughnessMapUrl: $roughnessMapUrl,
          aoMapUrl: $aoMapUrl,
          roughness: $materialRoughness,
          metalness: $materialMetalness,
          envMapIntensity: $materialEnvMapIntensity,
          specularIntensity: $materialSpecularIntensity,
          normalScale: $materialNormalScale,
          reflectivity: $materialReflectivity,
          repeatX: $repeatX,
          repeatY: $repeatY,
        })
      )
    ),

  attachComponent
    .withComponent(attributeSelectionComponent, 'hasCrossbrace', true)
    .withAlias('Base')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.hasCrossbrace],
        hasCrossbrace => ({
          value: hasCrossbrace,
          options: [
            {
              label: 'No Cross Brace',
              value: false,
            },
            {
              label: 'Cross Brace',
              value: true,
            },
          ],
        })
      ),
      state => {
        assertBoolean(state.value)
        return { hasCrossbrace: state.value }
      }
    ),

  attachComponent
    .withComponent(materialSwatchComponent, 'finish', true)
    .withAlias('Base')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.finish],
        finish => ({
          selectedSwatchKey: finish,
          swatches: {
            BlackTone: {
              color: '#111111',
              swatchName: 'Black Tone',
            },
            EbonyTone: {
              color: '#2C2C2C',
              swatchName: 'Ebony Tone',
            },
            Gray: {
              color: '#808080',
              swatchName: 'Gray',
            },
            DarkBrownTone: {
              color: '#4B3621',
              swatchName: 'Dark Brown Tone',
            },
            MediumBrownTone: {
              color: '#826344',
              swatchName: 'Medium Brown Tone',
            },
            LightBrownTone: {
              color: '#B3865E',
              swatchName: 'Light Brown Tone',
            },
            NaturalTone: {
              color: '#D2B48C',
              swatchName: 'Natural Tone',
            },
            Earthtone: {
              color: '#8B5E3C',
              swatchName: 'Earthtone',
            },
            Taupe: {
              color: '#483C32',
              swatchName: 'Taupe',
            },
            Custom: {
              color: '#FFFFFF',
              swatchName: 'Custom',
            },
          },
        })
      ),
      state => {
        Finishes.assert(state.selectedSwatchKey)
        return { finish: state.selectedSwatchKey }
      }
    ),
]
